import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Competences from './pages/Competences';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Loader from './components/Loader';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simule un chargement de 2 secondes
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer); // Nettoie le timer si le composant est démonté
  }, []);

  return (
    <LanguageProvider>
      <Router>
        {loading ? (
          <Loader />
        ) : (
          <div className="flex flex-col min-h-screen bg-white">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/competences" element={<Competences />} />
                <Route path="/services" element={<Services />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </div>
        )}
      </Router>
    </LanguageProvider>
  );
};

export default App;
